export const START_DATE_TEXT_FIELD_ID = 'startDateTextFieldId';
export const END_DATE_TEXT_FIELD_ID = 'endDateTextFieldId';
